module.exports = __webpack_public_path__ + "static/media/greenTheme-boy.5e9086d0.svg";